import {
  JsonSchemaPropertyMap,
  SectionFields,
  TypeAheadConfig,
} from "../../../../types";

export const GROUP_CODE_TYPE_TYPEAHEAD_CONFIG: TypeAheadConfig = {
  url: "/v2/search/GroupCodes",
  body: {
    filters: [],
    responseFields: [
      "group_code_type",
      "group_code_id",
      "group_code_description",
    ],
  },
  valueField: "group_code_id",
  labelField: ["group_code_id", "group_code_description"],
  storeId: "$group_codes_source_store",
};

export const GROUP_CODE_DIALOG_FIELDS_SCHEMA: JsonSchemaPropertyMap = {
  group_codes_source_store: {
    title: "Source Store",
    description: "The source store for the group codes to be copied from",
    type: "string",
    isStore: true,
    isHidden: true,
    enum: [],
    dependentFields: ["group_code_type"],
  },
  group_codes_source_group: {
    title: "Source Company",
    description: "The source company for the group codes to be copied from",
    type: "string",
    isGroupId: true,
    enum: [],
    dependentFields: ["group_code_type"],
  },
  group_codes_target_group: {
    title: "Target Company",
    description: "The target company for the group codes to be copied to",
    type: "string",
    isGroupId: true,
    enum: [],
    disabled: true,
  },
  group_code_type: {
    title: "Group Code Type",
    description: "The source store for the group codes to be copied from",
    type: "string",
    isStore: false,
    enum: [
      "Income/Balance Report Group",
      "Income/Balance Report Subgroup",
      "User Defined Report Group",
      "Unit Analysis Report Group",
    ],
    typeaheadConfig: GROUP_CODE_TYPE_TYPEAHEAD_CONFIG,
  },
};

export const PO_UNITS_OF_MEASURE_TYPEAHEAD_CONFIG: TypeAheadConfig = {
  url: "/v2/search/POUnitsOfMeasure",
  body: {
    filters: [],
    responseFields: ["uom_cd", "uom_desc"],
  },
  valueField: "uom_cd",
  labelField: ["uom_cd", "uom_desc"],
  storeId: "$source_store_id",
}; // removed active_sw from responseFields since we are not able to query it

export const PO_UNITS_OF_MEASURE_DIALOG_FIELDS_SCHEMA: JsonSchemaPropertyMap = {
  source_store_id: {
    title: "Store ID",
    description: "Source Store (Copy From)",
    type: "string",
    isStore: true,
    enum: [],
    dependentFields: ["destination_store_id"],
    isHidden: true,
    typeaheadConfig: PO_UNITS_OF_MEASURE_TYPEAHEAD_CONFIG,
  },
  source_group_id: {
    title: "Group ID",
    description: "Source Group (Copy From)",
    type: "string",
    isGroupId: true,
    enum: [],
    dependentFields: ["destination_store_id"],
    typeaheadConfig: PO_UNITS_OF_MEASURE_TYPEAHEAD_CONFIG,
  },
  destination_store_id: {
    title: "Store ID",
    description: "Destination Store (Copy To)",
    type: "string",
    isStore: true,
    enum: [],
    isHidden: true,
  },
  destination_group_id: {
    title: "Group ID",
    description: "Destination Group (Copy To)",
    type: "string",
    isGroupId: true,
    disabled: true,
    enum: [],
  },
};

//Confirmation Dialog Text
export const PO_UOM_COPY_CONFIRMATION_TEXT =
  "Copying UOM will overwrite UOM list and their active status . Do you wish to continue?";

//PO UOM to set default selected records
export const PO_UOM_ACTIVE_STATUS_FIELD = "active_sw";

export const ADDITIONAL_TOP_SECTIONS: SectionFields = {};

export const ADDITIONAL_BOTTOM_SECTIONS: SectionFields = {
  Discounts: {
    copy_settings_fields: {
      copy_discount_settings: {
        title: "Copy Settings",
        description: "Copy discount settings to another pay settings tab.",
        type: "discount-copy-settings-component",
      },
    },
  },
};

export const ADDITIONAL_FIELDS_FOR_SECTION: SectionFields = {
  VendorConfigurationGroup: {
    vendor_payment_fields: {
      vendor_payment_method_button: {
        title: "Payment Method",
        description:
          "This is button to add payment by using payment_type, payment_description, payment_category_type, routing_required",
        type: "button",
        requiresClear: true,
      },
    },
    vendor_company_fields: {
      vendor_company_button: {
        title: "Vendor Company",
        description: "This is button to save the Vendor Company types",
        type: "button",
        requiresClear: true,
      },
    },
    vendor_category_fields: {
      vendor_category_button: {
        title: "Vendor Category",
        description: "This is button to save the Vendor Company types",
        type: "button",
        requiresClear: true,
      },
    },
  },

  VendorCompanyType: {
    general_fields: {
      vendor_company_button: {
        title: "Vendor Company",
        description: "This is button to save the Vendor Company types",
        type: "button",
        requiresClear: true,
      },
    },
  },

  VendorCategory: {
    general_fields: {
      vendor_category_button: {
        title: "Vendor Category",
        description: "This is button to save the Vendor Category types",
        type: "button",
        requiresClear: true,
      },
    },
  },

  VendorPaymentTypes: {
    general_fields: {
      vendor_payments_button: {
        title: "Vendor Payment types",
        description: "This is button to save the Vendor Payment types",
        type: "button",
        requiresClear: true,
      },
    },
  },

  EtcAbsenceCodes: {
    general_fields: {
      absence_code_button: {
        title: "Absence Code",
        description: "This is button to add absence code & description",
        type: "button",
        requiresClear: true,
      },
    },
  },

  EtcHolidays: {
    general_fields: {
      holiday_button: {
        title: "Holiday",
        description: "This is button to add holiday",
        type: "button",
        requiresClear: true,
      },
    },
  },

  EtcPayrollFields: {
    general_fields: {
      payroll_field_button: {
        title: "Payroll Field",
        description: "This is button to add payroll field",
        type: "button",
        requiresClear: true,
      },
    },
  },

  EtcTardyCodes: {
    general_fields: {
      tardy_code_button: {
        title: "Tardy Code",
        description: "This is button to add tardy code & description",
        type: "button",
        requiresClear: true,
      },
    },
  },


  RemitToParent: {
    general_fields: {
      remit_to_parent_button: {
        title: "Remit To Parent",
        description: "This is button to save the Remit To Parent",
        type: "button",
        requiresClear: true,
      },
    },
  },

  //carDescModel and carDescMake
  Model: {
    general_fields: {
      car_desc_model_button: {
        title: "Car Description Model",
        description: "This is button to save the Car Description Model",
        type: "button",
        requiresClear: true,
      },
    },
  },

  Make: {
    general_fields: {
      car_desc_make_button: {
        title: "Car Description Make",
        description: "This is button to save the Car Description Make",
        type: "button",
        requiresClear: true,
      },
    },
  },

  Story: {
    general_fields: {
      story_button: {
        title: "Story",
        description: "This is button to save the Story",
        type: "button",
        requiresClear: true,
      },
    },
  },
  ReportGroupCodes: {
    general_fields: {
      group_codes_button: {
        title: "Group Codes",
        description: "This is button to save the Group Codes",
        type: "button",
        requiresClear: true,
      },
    },
  },
  POUnitsOfMeasure: {
    general_fields: {
      po_units_of_measure_button: {
        title: "PO Units of Measure",
        description: "This is a button to save the PO Units of Measure.",
        type: "button",
        requiresClear: true,
      },
    },
  },
  PaymentMappings: {
    general_fields: {
      payment_mappings_button: {
        title: "Payment Mappings",
        description: "This is button to save the Payment Mappings",
        type: "button",
        requiresClear: true,
      },
    },
  },
};
